import React from 'react'
import SewerageServiceCard from './SewerageServiceCard'
import { useNavigate } from 'react-router-dom'
import { Pie } from 'react-chartjs-2'
import { ServicePieoptions } from '../../../../../Helper/Data'


export default function SewerageServiceCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props

    const navigate = useNavigate()
    const SewerageWorkNavigate = (name, screenFlag) => {
        if (name === "Operation") {
            navigate(`/preventiveservicecommondata?name=${name}&ApiFlag=Operation&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&M_SW_WorkTypeID=2&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Electrical Maintenance") {
            navigate(`/preventiveservicecommondata?name=${name}&ApiFlag=Electrical&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&M_SW_WorkTypeID=4&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Mechanical Maintenance") {
            navigate(`/preventiveservicecommondata?name=${name}&ApiFlag=Mechanical&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&M_SW_WorkTypeID=3&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Civil Maintainance ") {
            navigate(`/preventiveservicecommondata?name=${name}&ApiFlag=Civil&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&M_SW_WorkTypeID=1&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }

    const ServicePiedata = {
        labels: ["Operation", "Electrical Maintainance"],
        datasets: [
            {
                // label: '# of Votes',
                data: [
                    Countdata && Countdata?.OperationServicesTotalCount,
                    Countdata && Countdata?.ElectricalServicesTotalCount,
                    // 50, 70
                ],
                backgroundColor: [
                    "#f48242",
                    "#ffc33d",

                ],
                borderColor: [
                    // '#28c8c1',
                    // '#172b4d',
                    // '#993366',
                    // '#593e89',
                    // '#94408e',
                    // '#c74382',
                    // '#fa5d00',
                    // '#529ad2',
                    // '#ffc137',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className='row'>
            <div className='col-12 col-lg-8'>
                <div className="row ps-lg-3">
                    <div className="col-12">
                        <h5 className="ps-2 py-2">Services</h5>
                    </div>

                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <SewerageServiceCard
                            title="Operation"
                            imgPath='./assets/img/engineering.png'
                            count={Countdata.OperationServicesTotalCount ? Countdata.OperationServicesTotalCount : '0'}
                            SewerageWorkNavigate={SewerageWorkNavigate}
                        />
                    </div>

                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <SewerageServiceCard
                            title="Electrical Maintenance"
                            imgPath='./assets/img/renewable-energy.png'
                            count={Countdata.ElectricalServicesTotalCount ? Countdata.ElectricalServicesTotalCount : '0'}
                            SewerageWorkNavigate={SewerageWorkNavigate}

                        />
                    </div>

                    {/* <div className="col-12 col-lg-3 mb-2">
                <SewerageServiceCard
                    title="Mechanical Maintenance"
                    imgPath='./assets/img/mechanics.png'
                    count={Countdata.MechanicalServicesTotalCount}
                    SewerageWorkNavigate={SewerageWorkNavigate}
                     />
            </div>

            <div className="col-12 col-lg-3 mb-2">
                <SewerageServiceCard
                    title="Civil Maintainance "
                    imgPath='./assets/img/engineers (1).png'
                    count={Countdata.CivilServicesTotalCount}
                    SewerageWorkNavigate={SewerageWorkNavigate}
                     />
            </div> */}


                </div>
            </div>
            <div className="col-12 col-lg-4">
                {/* <div className="row">
                    <div className="col-12">
                        <div className=" px-3 mt-3 pb-2 bg-white rounded rounded-3"> */}
                            {
                                (Countdata?.OperationServicesTotalCount != 0) || (Countdata?.ElectricalServicesTotalCount != 0) ?
                                    <div className="row d-flex justify-content-center align-items-center">
                                        <Pie
                                            height={130}
                                            // width={00}
                                            options={ServicePieoptions}
                                            data={ServicePiedata}
                                        />
                                    </div>
                                    :
                                    <div className='text-danger text-center pt-lg-5 fw-bolder'>
                                        No Data Found
                                    </div>
                            }
                        {/* </div>
                    </div>
                </div> */}
            </div>
        </div>
    )

}
